module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M19.992 9.009v1.999c0 .552.456.988.99 1.124 1.723.444 3.009 2.017 3.009 3.875s-1.286 3.431-3.009 3.875c-.534.136-.99.57-.99 1.124v1.999c0 .552.45 1.006.996.94a8 8 0 0 0 0-15.874c-.546-.066-.996.386-.996.94zM16.076.268L7.997 7.999H1.999C.893 7.999 0 8.985 0 10.068v11.9c0 1.084.894 2.025 1.999 2.025h5.998l8.121 7.817s1.875 1.128 1.875-2.123V2.223c0-3.291-1.917-1.955-1.917-1.955z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/speaker-2.js
// module id = 1428
// module chunks = 14